import { render, staticRenderFns } from "./GeneticSimilaritiesResult.vue?vue&type=template&id=184d6ce0&scoped=true"
import script from "./GeneticSimilaritiesResult.vue?vue&type=script&lang=js"
export * from "./GeneticSimilaritiesResult.vue?vue&type=script&lang=js"
import style0 from "./GeneticSimilaritiesResult.vue?vue&type=style&index=0&id=184d6ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d6ce0",
  null
  
)

export default component.exports